export default __webpack_public_path__ + "ececd46e83d19d2710e72c0f194ec0c7.png";